.searchCard {
  margin-bottom: 16px;
}

.batchActions {
  padding: 0 0 12px;
  margin-bottom: 16px;
  border-bottom: 1px solid var(--ant-color-border-secondary);
}

.userInfo {
  display: flex;
  gap: 12px;
  align-items: center;
}

.userName {
  font-weight: 500;
  color: var(--ant-color-text-heading);
}

.subText {
  font-size: 12px;
}

.premium {
  color: var(--ant-color-warning);
}

.preLine {
  white-space: pre-line;
}
